<template>
  <div id="twitter-trending-page">
    <!-- page header component -->
    <page-header-component
      icon="bi bi-twitter icon-sidebar"
      title="Twitter Trending Topik"
      :topik="false"
    />
    <!-- page component -->
    <transition name="block">
      <div>
        <transition name="block">
          <div id="card-trend" class="row mb-4" v-if="mounted">
            <div v-for="(row, index) in 4" :key="index" class="col-3">
              <score-card-component
                v-if="trending"
                :title="`Trending #${index + 1}`"
                :value_copy="
                  `${trending.trends[index]._id} ${trending.trends[
                    index
                  ].tweet_volume.toString()}`
                "
              >
                <div
                  style="
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  "
                >
                  <span
                    style="color: #000000; cursor: pointer"
                    @click="openURL(trending.trends[index].url)"
                  >
                    {{ trending.trends[index]._id }}
                  </span>
                  <span class="text-muted fs-12">
                    ({{ trending.trends[index].tweet_volume | shortNumber }}
                    tweets)
                  </span>
                </div>
              </score-card-component>
            </div>
          </div>
        </transition>
        <transition name="block">
          <div class="row" v-if="mounted">
            <div class="col-12">
              <div class="row">
                <div id="data-topik" class="col-4 px-gap">
                  <div class="card card-default shade" style="height: 100%">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <loader-component v-if="is_loading" />
                          <div v-else>
                            <table-dynamic-component
                              v-if="barchart"
                              :data_head="['Topik', 'Tweets', 'Aksi']"
                              :data_head_class="[
                                { head: 'Tweets', class: 'text-center' },
                                { head: 'Aksi', class: 'text-center' },
                              ]"
                              :data_body="data_body"
                              table_class="table-stripped"
                              table_id="twitter-trending-table"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="data-trend-per" class="col-8 px-gap">
                  <div class="card card-default shade" style="height: 100%">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <p v-if="trending" class="h6 mb-5">
                            Data Trending per {{ trending.as_of }}
                          </p>
                          <loader-component v-if="is_loading" />
                          <div v-else>
                            <bar-chart-component
                              v-if="barchart"
                              :dataset="barchart.series"
                              :y-label="barchart.yLabel"
                              barchart_id="media-cetak-barchart"
                            />
                            <div v-else class="col-md-12 col-sm-12 col-lg-12">
                              <div
                                class="alert alert-danger mt-3"
                                id="errorApiEl"
                                role="alert"
                                align="center"
                              >
                                <strong
                                  >Mohon maaf, data tidak tersedia!
                                </strong>
                                <br />
                                Silahkan lakukan pencarian dengan parameter lain
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
    <!-- tour component -->
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    />
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import loader from "@/views/components/loader.vue";
import score_card from "@/views/components/score_card.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";
import bar_chart_highchart from "@/views/components/chart/bar_chart_highchart.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "TwitterTrending",
  title: "Twitter Trending | Sibernetik",
  components: {
    "page-header-component": page_header,
    "loader-component": loader,
    "score-card-component": score_card,
    "table-dynamic-component": table_dynamic,
    "bar-chart-component": bar_chart_highchart,
  },
  data() {
    return {
      is_trending: this.$store.getters.user.project.project_detail
        .twitter_trending
        ? true
        : false,
      data_body: [],
      trending: null,
      barchart: null,
      mounted: false,
      is_loading: true,
      tour_steps: [],
    };
  },
  methods: {
    getData: function() {
      this.is_loading = true;
      let params = {
        from: this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        to: this.$store.getters.filter_date_to.format("YYYY-MM-DD HH:mm:ss"),
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL + "new-twitter-trending" + "?" + query;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.trending = response.data;
            this.assembleBarchart(this.trending.trends);
            this.trending.trends = this.trending.trends.sort(this.compare);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    assembleBarchart: function(dataset) {
      let data = [];
      dataset.forEach((element) => {
        if (element.tweet_volume) {
          data.push([
            element._id,
            element.tweet_volume,
            `<a href="${element.url}" target="_blank" class="btn btn-warning btn-icon-left m-b-10"><i class="bi bi-box-arrow-up-right mr-1" style="font-size:10px; color: #ff9f43;"></i> <small style="color: #ff9f43;"> Kunjungi </small></a>`,
            // `<a href="${element.url}" target="_blank" class="btn btn-sm btn-complete"><i class="bi bi-box-arrow-up-right mr-1" style="font-size:10px"></i> <small> Kunjungi </small></a>`,
          ]);
        }
      });
      data.forEach((el) => {
        this.data_body.push([
          el[0],
          `<center>${gp.kmbFormatter(el[1])}</center>`,
          el[2],
        ]);
      });
      this.barchart = {
        series: data,
        yLabel: "Total Tweet",
      };
    },
    compare: function(a, b) {
      if (a.tweet_volume > b.tweet_volume) {
        return -1;
      }
      if (a.tweet_volume < b.tweet_volume) {
        return 1;
      }
      return 0;
    },
    openURL: function(url) {
      window.open(url, "_blank");
    },
  },
  watch: {
    $route() {
      this.getData();
    },
  },
  created: function() {
    this.getData();
  },
  mounted: function() {
    this.mounted = true;
    let v_step = [];
    v_step[0] = {
      target: "#card-trend",
      header: {
        title: "Trending Topik",
      },
      content: "Menampilkan Top 4 Topik Trending di Twitter",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#data-topik",
      header: {
        title: "Data Topik",
      },
      content:
        "Menampilkan daftar topik dengan jumlah tweets untuk setiap topiknya",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#data-trend-per",
      header: {
        title: "Data Trending",
      },
      content:
        "Menampilkan Grafik data trending topik dalam periode waktu tertentu",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>
